import siteType from "../configs/siteType"

/* eslint-disable */
let register = {}
if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
  register = {
    LAB_CLUB_INVITE_H5_WELCOME: 'Velkommen til {club}',
    LAB_CLUB_INVITE_H5_WELCOME_LONG: 'Du bliver medlem af klubben ved registrering',
    LAB_REGISTER_USERNAME: 'Brugernavn',
    LAB_AUTH_EMAIL: 'E-mail',
    LAB_ACCOUNT_EMAIL_FORM_WRONG: 'Ugyldigt e-mailformat',
    LAB_ACCOUNT_ALREADY_REGISTERED: '*Denne e-mail er allerede blevet brugt til registrering.',
    LAB_KYC_INVALID_EMAIL: 'Denne e-mailadresse kan ikke bruges.',
    LAB_ACCOUNT_FORMAT_TIP: '*Brugernavn skal indeholde 4 til 30 bogstaver eller cifre.',
    LAB_ACCOUNT_FORMAT_TIP2: '*Brugernavn kræver iingen mellemrum eller specialtegn.',
    LAB_PASSWORD: 'Adgangskode',
    LAB_REGISTER_PASSWORD_TIP2: 'Adgangskoden skal bestå af 6-16 tegn og inkludere mindst et bogstav og et tal.',
    LAB_REGISTER_PASSWORD_TIP3: '{word} kan ikke anvendes i din adgangskode.',
    LAB_REGISTER_PASSWORD_TIP4: 'Mellemrum kan ikke anvendes i din adgangskode.',
    LAB_CLUB_INVITE_H5_Verifiy: 'Bekræftelseskode',
    LAB_VERIFICATION_CODE_ERROR: 'Forkert bekræftelseskode',
    LAB_REGISTER_RIGHT_NOW: 'Registrer',
    LAB_CLUB_INVITE_H5_Download_1: 'Har du en konto?',
    LAB_CLUB_INVITE_H5_Download_2: 'Download nu',
    LAB_CLUB_INVITE_H5_Success: 'Registrering lykkedes!',
    LAB_CLUB_CHECK_TEMS1: 'Marker her for at angive, at du er over 18 år, og at du har læst og accepteret:',
    LAB_CLUB_CHECK_TEMS2: 'Vilkår for service',
    LAB_CLUB_CHECK_TEMS3: 'og',
    LAB_CLUB_CHECK_TEMS4: 'Privatlivspolitik',
    LAB_CLUB_CHECK_TIPS: 'Angiv, at du er enig i Vilkår for service og Privatlivspolitikken',
    LAB_REGISTER_MUCH: 'Multiregistrering er ikke tilladt!',
    LAB_CLUB_INVITE_CODE_ERROR: 'Ugyldig invitationskode!',
    LAB_HISTORY_SHARE_ERROR: 'Anmodning mislykkedes, prøv igen senere.',
    LAB_H5_Marketing_Programme: 'Vilkår og betingelser for partnermarketing-programmet',
    LAB_H5_CHECK_TIPS: 'Marker her for at angive, at du er over 18 år, og at du har læst og accepteret: {link1}, {link2} og {link3}.',       
    LAB_PLAY_NOW: 'Spil nu!',
    LAB_TITLE_1: 'GARANTERET CASHBACK',
    LAB_CONTENT_1: 'Op til 50 % øjeblikkelig tilbagebetaling kan indsamles efter hvert spil!',
    LAB_TITLE_2: 'GLOBALE SPILLERE',
    LAB_CONTENT_2: 'Et udvalg af spændende spil, der kører 24/7!',
    LAB_TITLE_3: 'BONUSSER UDEN STOP',
    LAB_CONTENT_3: 'Spil for at optjene ENORME belønninger fra vores ranglister, kontantstorm, missioner og jackpots.',
    LAB_TITLE_4: 'MIDLER BESKYTTET',
    LAB_CONTENT_4: 'Niveau 1 online-pokerlicens fra Isle of Mans gamblingkommission.',
    LAB_BE_MORE: 'Vær mere end bare en spiller på NUTS POKER!',
    LAB_PLAY_BEST: 'Spil det bedste pokerspil nu!',
    LAB_ENJOY: 'NYD FORSKELLIGE \r\nPOKERFORMATER',
    LAB_MORE: 'NLH, PLO, OFC med flere!',
    LAB_PLAY_GAME: 'Spil med os for at opleve et bredt udvalg af pokerspil!',
    LAB_MODE: "Vi tilbyder forskellige pokerspil, fra de klassiske til de trendy, herunder No-Limit Texas Hold'em, PLO, 6+ og OFC - med spændende varianter, herunder Aggressiv, Ultimativ og Joker-tilstande.",
    LAB_TODAY: 'Vær med, hvor det sker, i dag!',
    LAB_ACTION: 'TREDOBBELT HANDLING \r\nTREDOBBELT SJOV',
    LAB_MASTER: 'Bliv flerbords-mester',
    LAB_SAME_TIME: 'Med flerbords-funktionen kan du spille op til \r\n' +
      'tre borde på din enhed på samme tid!',
    LAB_SWIPE: 'For at få den bedste brugeroplevelse bliver bordene automatisk fremhævet \r\n' +
      ', når det er din tur, så du hurtigt kan komme videre til næste del af handlingen.',
    LAB_SAFE: 'SIKKER OG FAIR \r\nSPILOPLEVELSE',
    LAB_ASSEM: 'Dedikeret team til bekæmpelse af snyd!',
    LAB_RULES: 'NUTS POKER har nultolerance over for unfair spil, \r\n' +
      'og vil permanent udelukke konti, der overtræder reglerne.',
    LAB_TABLES: 'Der implementeres mekanismer til bekæmpelse af snyd for at sørge for, at adfærd genkendes, \r\n' +
      'med et team af eksperter, der holder øje med bordene.',
    LAB_EVERY_DAY: 'Nyd et fair og sikkert spil på NUTS POKER hver dag!',
    LAB_COUNTRIES: 'visse lande',
    LAB_ABOUT: 'Om os',
    LAB_POLICY: 'Privatlivspolitik',
    LAB_TERM: 'Vilkår for service',
    LAB_COPY: 'Copyright © {link} NUTS POKER. Alle rettigheder forbeholdes.',
    LAB_DOWNLOAD: 'DOWNLOAD',
    LAB_VERIFICATION: 'Verifikation',
    LAB_PLEASE_TYPE: 'Skriv teksten i billedet',
    LAB_CONFIRM: 'BEKRÆFT',
    LAB_SERVICE: 'De produkter og tjenester, som NUTS POKER tilbyder (via sine websteder, tablet- og mobilapplikationer), er tilsammen benævnt “tjenesterne”.',
    LAB_ACCESS: 'Adgang til tjenester er muligvis ikke lovligt for beboere i eller personer, der befinder sig i {link}. Tjenester, der leveres herunder, er ikke et tilbud, en opfordring eller en invitation fra NUTS POKER til brug af eller abonnement på betting, spil eller andre tjenester i nogen jurisdiktion, hvor sådanne aktiviteter er forbudt ved lov. Navnlig må indbyggere eller personer, der befinder sig i USA, ikke bruge nogen af tjenesterne.',
    LAB_BRAND: 'NUTS POKER er et brand og et registreret virksomhedsnavn, der ejes af AceKing IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IM1 2LD.',
    LAB_GAMEBLING: 'Reguleret og licenseret af Isle of Mans tilsynskommission for gambling i henhold til online gambling',
    LAB_AGE: 'Lov om regulering 2001 siden 24. juli 2019 (Sidste fornyelse: 24. juli 2019). Personer under 18 år må ikke oprette konti og/eller deltage i gambling. Eventuelle indskud eller gevinster hos NUTS POKER er sikre og kan håndhæves i henhold til Isle of Mans lovgivning.',   
    LAB_SERVICE_CO: 'De produkter og tjenester, som NUTS POKER Global tilbyder (via sine websteder, tablet- og mobilapplikationer), er tilsammen benævnt “tjenesterne”.',
    LAB_ACCESS_CO: 'Adgang til tjenester er muligvis ikke lovligt for beboere i eller personer, der befinder sig i visse lande. Tjenester, der leveres herunder, er ikke et tilbud, en opfordring eller en invitation fra NUTS POKER Global til brug af eller abonnement på betting, spil eller andre tjenester i nogen jurisdiktion, hvor sådanne aktiviteter er forbudt ved lov. Navnlig må indbyggere eller personer, der befinder sig i USA, ikke bruge nogen af tjenesterne.',
    LAB_BRAND_CO: 'NUTS POKER.co drives af Violet Fortune Tech Limited N.V. registreret under nr. 158923 på Perseusweg 27A, Willemstad, Curaçao. Dette websted er licenseret og reguleret af Curaçao eGaming (Curaçao-licens nr. 1668 JAZ udstedt af Curaçao eGaming).',
    LAB_GAMEBLING_CO: 'Alle indskud eller gevinster hos NUTS POKER Global er sikre og kan håndhæves i henhold til Curaçaos lovgivning.',        
    LAB_AGE_CO: 'Personer under 18 år må ikke oprette konti og/eller deltage i gambling.',
    LAB_CLUB_CHECK_TEMS4_CO: 'Privatliv og håndtering af personoplysninger',
    LAB_PRIVACYPOLICE_CO: 'Privatliv og personoplysninger',
    LAB_CONTENT_4_CO: 'Fuldt licenseret og reguleret af Curaçao eGaming.',
    LAB_VERIFY_EMAIL: 'Bekræft din e-mail',
    LAB_VERIFY_EMAIL_ADDRESS: 'Vi har sendt en e-mail til {email address}',
    LAB_VERIFY_TIPS: 'For at bekræfte din e-mailadresse og aktivere din konto skal du klikke på det link til verifikation, der er sendt til din e-mail. Den kan ligge i din spam-mappe.',
    LAB_VERIFY_RESEND: 'Send e-mail igen',
    LAB_VERIFY_CODE_TIPS: 'Skriv teksten, der vises på billedet, for at bekræfte, at du ikke er en robot.',
    LAB_EMAIL_VERIFIED: 'E-mail bekræftet',
    LAB_EMAIL_DOWNLOAD_TIPS: 'Din konto er blevet oprettet. <br>Klik på knapperne nedenfor for at downloade NUTS POKER og begynde at spille.',
    LAB_EMAIL_DOWNLOAD: 'Download NUTS POKER',
    LAB_EMAIL_VERIFY_ACCOUNT: 'Bekræft din NUTS POKER-Konto',
    LAB_EMAIL_EXPIRED_1: 'Ups, linket er udløbet',
    LAB_EMAIL_EXPIRED_2: 'Fortsæt til registreringssiden for at anmode om et nyt link til verifikation.',
    LAB_VERIFY_PROTECT: 'Se, hvordan vi beskytter dine personoplysninger',
    LAB_EMAIL_FAILED: 'Mislykkedes. Prøv igen senere',
  }
} else {
  register = {
    LAB_CLUB_INVITE_H5_WELCOME: 'Velkommen til {club}',
    LAB_CLUB_INVITE_H5_WELCOME_LONG: 'Du bliver medlem af klubben ved registrering',
    LAB_REGISTER_USERNAME: 'Brugernavn',
    LAB_AUTH_EMAIL: 'E-mail',
    LAB_ACCOUNT_EMAIL_FORM_WRONG: 'Ugyldigt e-mailformat',
    LAB_ACCOUNT_ALREADY_REGISTERED: '*Denne e-mail er allerede blevet brugt til registrering.',
    LAB_KYC_INVALID_EMAIL: 'Denne e-mailadresse kan ikke bruges.',
    LAB_ACCOUNT_FORMAT_TIP: '*Brugernavn skal indeholde 4 til 30 bogstaver eller cifre.',
    LAB_ACCOUNT_FORMAT_TIP2: '*Brugernavn kræver iingen mellemrum eller specialtegn.',
    LAB_PASSWORD: 'Adgangskode',
    LAB_REGISTER_PASSWORD_TIP2: 'Adgangskoden skal bestå af 8-16 tegn og indeholde store og små bogstaver samt tal.',
    LAB_REGISTER_PASSWORD_TIP3: '{word} kan ikke anvendes i din adgangskode.',
    LAB_REGISTER_PASSWORD_TIP4: 'Mellemrum kan ikke anvendes i din adgangskode.',
    LAB_CLUB_INVITE_H5_Verifiy: 'Bekræftelseskode',
    LAB_VERIFICATION_CODE_ERROR: 'Forkert bekræftelseskode',
    LAB_REGISTER_RIGHT_NOW: 'Registrer',
    LAB_CLUB_INVITE_H5_Download_1: 'Har du en konto?',
    LAB_CLUB_INVITE_H5_Download_2: 'Download nu',
    LAB_CLUB_INVITE_H5_Success: 'Registrering lykkedes!',
    LAB_CLUB_CHECK_TEMS1: 'Marker her for at angive, at du er over 18 år, og at du har læst og accepteret:',
    LAB_CLUB_CHECK_TEMS2: 'Vilkår for service',
    LAB_CLUB_CHECK_TEMS3: 'og',
    LAB_CLUB_CHECK_TEMS4: 'Privatlivspolitik',
    LAB_CLUB_CHECK_TIPS: 'Angiv, at du er enig i Vilkår for service og Privatlivspolitikken',
    LAB_REGISTER_MUCH: 'Multiregistrering er ikke tilladt!',
    LAB_CLUB_INVITE_CODE_ERROR: 'Ugyldig invitationskode!',
    LAB_HISTORY_SHARE_ERROR: 'Anmodning mislykkedes, prøv igen senere.',
    LAB_H5_Marketing_Programme: 'Vilkår og betingelser for partnermarketing-programmet',
    LAB_H5_CHECK_TIPS: 'Marker her for at angive, at du er over 18 år, og at du har læst og accepteret: {link1}, {link2} og {link3}.',       
    LAB_PLAY_NOW: 'Spil nu!',
    LAB_TITLE_1: 'GARANTERET CASHBACK',
    LAB_CONTENT_1: 'Op til 50 % øjeblikkelig tilbagebetaling kan indsamles efter hvert spil!',
    LAB_TITLE_2: 'GLOBALE SPILLERE',
    LAB_CONTENT_2: 'Et udvalg af spændende spil, der kører 24/7!',
    LAB_TITLE_3: 'BONUSSER UDEN STOP',
    LAB_CONTENT_3: 'Spil for at optjene ENORME belønninger fra vores ranglister, kontantstorm, missioner og jackpots.',
    LAB_TITLE_4: 'MIDLER BESKYTTET',
    LAB_CONTENT_4: 'Niveau 1 online-pokerlicens fra Isle of Mans gamblingkommission.',
    LAB_BE_MORE: 'Vær mere end bare en spiller på KKPoker!',
    LAB_PLAY_BEST: 'Spil det bedste pokerspil nu!',
    LAB_ENJOY: 'NYD FORSKELLIGE \r\nPOKERFORMATER',
    LAB_MORE: 'NLH, PLO, OFC med flere!',
    LAB_PLAY_GAME: 'Spil med os for at opleve et bredt udvalg af pokerspil!',
    LAB_MODE: "Vi tilbyder forskellige pokerspil, fra de klassiske til de trendy, herunder No-Limit Texas Hold'em, PLO, 6+ og OFC - med spændende varianter, herunder Aggressiv, Ultimativ og Joker-tilstande.",
    LAB_TODAY: 'Vær med, hvor det sker, i dag!',
    LAB_ACTION: 'TREDOBBELT HANDLING \r\nTREDOBBELT SJOV',
    LAB_MASTER: 'Bliv flerbords-mester',
    LAB_SAME_TIME: 'Med flerbords-funktionen kan du spille op til \r\n' +
      'tre borde på din enhed på samme tid!',
    LAB_SWIPE: 'For at få den bedste brugeroplevelse bliver bordene automatisk fremhævet \r\n' +
      ', når det er din tur, så du hurtigt kan komme videre til næste del af handlingen.',
    LAB_SAFE: 'SIKKER OG FAIR \r\nSPILOPLEVELSE',
    LAB_ASSEM: 'Dedikeret team til bekæmpelse af snyd!',
    LAB_RULES: 'KKPoker har nultolerance over for unfair spil, \r\n' +
      'og vil permanent udelukke konti, der overtræder reglerne.',
    LAB_TABLES: 'Der implementeres mekanismer til bekæmpelse af snyd for at sørge for, at adfærd genkendes, \r\n' +
      'med et team af eksperter, der holder øje med bordene.',
    LAB_EVERY_DAY: 'Nyd et fair og sikkert spil på KKPoker hver dag!',
    LAB_COUNTRIES: 'visse lande',
    LAB_ABOUT: 'Om os',
    LAB_POLICY: 'Privatlivspolitik',
    LAB_TERM: 'Vilkår for service',
    LAB_COPY: 'Copyright © {link} KKPoker. Alle rettigheder forbeholdes.',
    LAB_DOWNLOAD: 'DOWNLOAD',
    LAB_VERIFICATION: 'Verifikation',
    LAB_PLEASE_TYPE: 'Skriv teksten i billedet',
    LAB_CONFIRM: 'BEKRÆFT',
    LAB_SERVICE: 'De produkter og tjenester, som KKPoker tilbyder (via sine websteder, tablet- og mobilapplikationer), er tilsammen benævnt “tjenesterne”.',
    LAB_ACCESS: 'Adgang til tjenester er muligvis ikke lovligt for beboere i eller personer, der befinder sig i {link}. Tjenester, der leveres herunder, er ikke et tilbud, en opfordring eller en invitation fra KKPoker til brug af eller abonnement på betting, spil eller andre tjenester i nogen jurisdiktion, hvor sådanne aktiviteter er forbudt ved lov. Navnlig må indbyggere eller personer, der befinder sig i USA, ikke bruge nogen af tjenesterne.',
    LAB_BRAND: 'KKPoker er et brand og et registreret virksomhedsnavn, der ejes af AceKing IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IM1 2LD.',
    LAB_GAMEBLING: 'Reguleret og licenseret af Isle of Mans tilsynskommission for gambling i henhold til online gambling',
    LAB_AGE: 'Lov om regulering 2001 siden 24. juli 2019 (Sidste fornyelse: 24. juli 2019). Personer under 18 år må ikke oprette konti og/eller deltage i gambling. Eventuelle indskud eller gevinster hos KKPoker er sikre og kan håndhæves i henhold til Isle of Mans lovgivning.',   
    LAB_SERVICE_CO: 'De produkter og tjenester, som KKPoker Global tilbyder (via sine websteder, tablet- og mobilapplikationer), er tilsammen benævnt “tjenesterne”.',
    LAB_ACCESS_CO: 'Adgang til tjenester er muligvis ikke lovligt for beboere i eller personer, der befinder sig i visse lande. Tjenester, der leveres herunder, er ikke et tilbud, en opfordring eller en invitation fra KKPoker Global til brug af eller abonnement på betting, spil eller andre tjenester i nogen jurisdiktion, hvor sådanne aktiviteter er forbudt ved lov. Navnlig må indbyggere eller personer, der befinder sig i USA, ikke bruge nogen af tjenesterne.',
    LAB_BRAND_CO: 'kkpoker.co drives af Violet Fortune Tech Limited N.V. registreret under nr. 158923 på Perseusweg 27A, Willemstad, Curaçao. Dette websted er licenseret og reguleret af Curaçao eGaming (Curaçao-licens nr. 1668 JAZ udstedt af Curaçao eGaming).',
    LAB_GAMEBLING_CO: 'Alle indskud eller gevinster hos KKPoker Global er sikre og kan håndhæves i henhold til Curaçaos lovgivning.',        
    LAB_AGE_CO: 'Personer under 18 år må ikke oprette konti og/eller deltage i gambling.',
    LAB_CLUB_CHECK_TEMS4_CO: 'Privatliv og håndtering af personoplysninger',
    LAB_PRIVACYPOLICE_CO: 'Privatliv og personoplysninger',
    LAB_CONTENT_4_CO: 'Fuldt licenseret og reguleret af Curaçao eGaming.',
    LAB_VERIFY_EMAIL: 'Bekræft din e-mail',
    LAB_VERIFY_EMAIL_ADDRESS: 'Vi har sendt en e-mail til {email address}',
    LAB_VERIFY_TIPS: 'For at bekræfte din e-mailadresse og aktivere din konto skal du klikke på det link til verifikation, der er sendt til din e-mail. Den kan ligge i din spam-mappe.',
    LAB_VERIFY_RESEND: 'Send e-mail igen',
    LAB_VERIFY_CODE_TIPS: 'Skriv teksten, der vises på billedet, for at bekræfte, at du ikke er en robot.',
    LAB_EMAIL_VERIFIED: 'E-mail bekræftet',
    LAB_EMAIL_DOWNLOAD_TIPS: 'Din konto er blevet oprettet. <br>Klik på knapperne nedenfor for at downloade KKPoker og begynde at spille.',
    LAB_EMAIL_DOWNLOAD: 'Download KKPoker',
    LAB_EMAIL_VERIFY_ACCOUNT: 'Bekræft din KKPoker-Konto',
    LAB_EMAIL_EXPIRED_1: 'Ups, linket er udløbet',
    LAB_EMAIL_EXPIRED_2: 'Fortsæt til registreringssiden for at anmode om et nyt link til verifikation.',
    LAB_VERIFY_PROTECT: 'Se, hvordan vi beskytter dine personoplysninger',
    LAB_EMAIL_FAILED: 'Mislykkedes. Prøv igen senere',
    LAB_MIT_CANCEL: 'MitID-verificeringen blev annulleret. Prøv igen for at fortsætte.',
    LAB_MITID_ALREADYLINKED_TIP: "Dette MitID er allerede tilknyttet en anden konto. Log ind med den tilknyttede e-mail: ({email})",
    LAB_MITID_CPR_STATUS_ERROR: "Vi er stødt på et problem med din CPR-registreringsstatus og kan ikke verificere din konto automatisk på nuværende tidspunkt.\nKontakt info@kkpoker.dk, hvis du har brug for hjælp, og oplys denne fejlkode som reference.\nFejlkode {code}",
    LAB_MITID_CLIENT_RETURN_TIP: "Vend tilbage til KKPoker for at fortsætte",
    LAB_AUTH_CPR_NUMBER: "CPR Number",
    LAB_AUTH_NAME: "Name",
    LAB_CPR_ERROR: "Invalid CPR number format",
    LAB_CPR_INVALID: "*Invalid CPR number",
    LAB_CPR_MINOR: "*CPR number belongs to a minor.",
  }
}

export default {
  "register": register
}